import { render, staticRenderFns } from "./c_home_merchant.vue?vue&type=template&id=36b921e3&scoped=true"
import script from "./c_home_merchant.vue?vue&type=script&lang=js"
export * from "./c_home_merchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b921e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\fenxijunya-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b921e3')) {
      api.createRecord('36b921e3', component.options)
    } else {
      api.reload('36b921e3', component.options)
    }
    module.hot.accept("./c_home_merchant.vue?vue&type=template&id=36b921e3&scoped=true", function () {
      api.rerender('36b921e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfig/c_home_merchant.vue"
export default component.exports